
import * as Sentry from "@sentry/vue";
const SentryExceptionHandler = {
  install(Vue){
    Vue.mixin({
      methods: {
        captureException(exception) {
          Sentry.captureException(exception);
        },
        captureMessage(message){
          Sentry.captureMessage(message);
        }
      },
    });
  }  
}
export default SentryExceptionHandler;